import { applyStatusFilter } from './ApplyStatusFilter';

export const statusOfSlot = (metricName, statusFilter, data, selectionTime) => {
    const trendData = data.trends?.[metricName]?.data;
    if (!trendData) return 'gray';
    const filteredData = applyStatusFilter(trendData, statusFilter);
    const matching = filteredData.filter((slot) => slot.date === selectionTime);
    if (!matching.length) return 'gray';
    const slot = matching[0];
    if (slot.value.red) return 'red';
    if (slot.value.orange) return 'orange';
    if (slot.value.yellow) return 'yellow';
    if (slot.value.green) return 'green';
    return 'gray';
};
